"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorScorecardSchema = exports.HeatmapStatsSchema = exports.HeatmapRowSchema = exports.HeatmapCellSchema = exports.BootstrapCiSchema = exports.PairedTestResultSchema = exports.WinRateStatsSchema = exports.CohortCutoffsSchema = exports.CohortUserSummarySchema = exports.FailedEvalSummarySchema = exports.PlanEvalDetailSchema = exports.StepDetailSchema = exports.PlanEvalHistoryEntrySchema = exports.ScoredPlanSummarySchema = exports.OperatorSummarySchema = exports.PACKAGE_EVAL_PROPERTY_METRIC_KINDS = exports.PACKAGE_EVAL_PROPERTY_KEYS = exports.BOUNDARY_PROPERTY_KEYS = exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS = exports.DECOMPOSED_BOUNDARY_STEP_KEY = exports.OPERATOR_EVAL_STEP_METRIC_KINDS = void 0;
exports.metricKindLabel = metricKindLabel;
const zod_1 = require("zod");
const statistical_significance_rating_1 = require("../DataScience/Types/statistical-significance-rating");
function metricKindLabel(kind) {
    switch (kind) {
        case 'f1':
            return 'F1';
        case 'setF1':
            return 'Set F1';
        case 'ted':
            return 'TED';
    }
}
exports.OPERATOR_EVAL_STEP_METRIC_KINDS = {
    AssignSigmaModelType: 'f1',
    ExtractBoundaries: 'setF1',
    ExtractFunctions: 'ted',
    ExtractModes: 'f1',
    ExtractParameters: 'f1',
    ExtractResources: 'f1',
    ExtractSignalDriveModes: 'f1',
    'ExtractSignals+ExtractPinout': 'f1',
    GenerateImplementationRules: 'setF1',
};
exports.DECOMPOSED_BOUNDARY_STEP_KEY = 'ExtractBoundaries';
exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS = {
    'ExtractSignals+ExtractPinout': 'signals_pinout',
    ExtractFunctions: 'functions',
    ExtractModes: 'modes',
    ExtractParameters: 'parameters',
    ExtractResources: 'resources',
    ExtractSignalDriveModes: 'drive_modes',
    AssignSigmaModelType: 'sigma_model_type',
    GenerateImplementationRules: 'implementation_rules',
};
exports.BOUNDARY_PROPERTY_KEYS = {
    absoluteMaximumRatings: 'absolute_maximum_ratings',
    operatingConditions: 'operating_conditions',
};
exports.PACKAGE_EVAL_PROPERTY_KEYS = [
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS['ExtractSignals+ExtractPinout'],
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.ExtractFunctions,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.ExtractModes,
    exports.BOUNDARY_PROPERTY_KEYS.absoluteMaximumRatings,
    exports.BOUNDARY_PROPERTY_KEYS.operatingConditions,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.ExtractParameters,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.ExtractResources,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.ExtractSignalDriveModes,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.AssignSigmaModelType,
    exports.OPERATOR_EVAL_STEP_PROPERTY_KEYS.GenerateImplementationRules,
];
exports.PACKAGE_EVAL_PROPERTY_METRIC_KINDS = {
    signals_pinout: 'f1',
    functions: 'ted',
    modes: 'f1',
    absolute_maximum_ratings: 'setF1',
    operating_conditions: 'setF1',
    parameters: 'f1',
    resources: 'f1',
    drive_modes: 'f1',
    sigma_model_type: 'f1',
    implementation_rules: 'setF1',
};
exports.OperatorSummarySchema = zod_1.z.object({
    userId: zod_1.z.string(),
    displayLabel: zod_1.z.string(),
    completedReviewCount: zod_1.z.number().int().nonnegative(),
});
const OperatorRefSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    displayLabel: zod_1.z.string(),
});
exports.ScoredPlanSummarySchema = zod_1.z.object({
    reviewId: zod_1.z.string().nullable(),
    planId: zod_1.z.string(),
    completedAt: zod_1.z.string().nullable(),
    evaluatedAt: zod_1.z.string(),
    evalVersion: zod_1.z.string(),
    groundTruthUpdatedAt: zod_1.z.string(),
    aggregatePrimaryScore: zod_1.z.number(),
    stepScores: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    packageId: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string(),
    packageSigmaModelType: zod_1.z.string(),
    opSigmaModelType: zod_1.z.string().nullable(),
    operator: OperatorRefSchema.nullable(),
    aiAggregatePrimaryScore: zod_1.z.number().nullable(),
    aiStepScores: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    overallDelta: zod_1.z.number().nullable(),
    stepDeltas: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
});
exports.PlanEvalHistoryEntrySchema = zod_1.z.object({
    evaluatedAt: zod_1.z.string(),
    evalVersion: zod_1.z.string(),
    aggregatePrimaryScore: zod_1.z.number(),
});
const AttributionCountsSchema = zod_1.z.object({
    improved: zod_1.z.number().int().nonnegative(),
    regressed: zod_1.z.number().int().nonnegative(),
    unchanged: zod_1.z.number().int().nonnegative(),
    added: zod_1.z.number().int().nonnegative(),
    removed: zod_1.z.number().int().nonnegative(),
});
exports.StepDetailSchema = zod_1.z.object({
    taskName: zod_1.z.string(),
    score: zod_1.z.number().nullable(),
    groundTruth: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    inferred: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    aiInferred: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullable(),
    attribution: AttributionCountsSchema.nullable(),
});
exports.PlanEvalDetailSchema = zod_1.z.object({
    summary: exports.ScoredPlanSummarySchema,
    history: zod_1.z.array(exports.PlanEvalHistoryEntrySchema),
    steps: zod_1.z.array(exports.StepDetailSchema).default([]),
});
exports.FailedEvalSummarySchema = zod_1.z.object({
    reviewId: zod_1.z.string().nullable(),
    planId: zod_1.z.string(),
    evalVersion: zod_1.z.string(),
    errorClass: zod_1.z.string(),
    errorMessage: zod_1.z.string(),
    failedAt: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    packageSigmaModelType: zod_1.z.string().nullable(),
});
const CohortPhaseSchema = zod_1.z.object({
    total: zod_1.z.number().int(),
    complete: zod_1.z.number().int(),
    score: zod_1.z.number().nullable(),
});
exports.CohortUserSummarySchema = zod_1.z.object({
    userId: zod_1.z.string(),
    displayLabel: zod_1.z.string(),
    cohort: zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal(2), zod_1.z.literal(3)]),
    phase1: CohortPhaseSchema,
    phase2: CohortPhaseSchema.nullable(),
});
exports.CohortCutoffsSchema = zod_1.z
    .object({ start: zod_1.z.string().optional(), end: zod_1.z.string().optional() })
    .refine((v) => v.start !== undefined || v.end !== undefined, {
    message: 'At least one of start or end must be provided',
});
exports.WinRateStatsSchema = zod_1.z.object({
    winRate: zod_1.z.number(),
    lossRate: zod_1.z.number(),
    tieRate: zod_1.z.number(),
    n: zod_1.z.number().int().nonnegative(),
    ciLow: zod_1.z.number(),
    ciHigh: zod_1.z.number(),
});
exports.PairedTestResultSchema = zod_1.z.object({
    meanDelta: zod_1.z.number(),
    stdDev: zod_1.z.number(),
    n: zod_1.z.number().int().nonnegative(),
    pValue: zod_1.z.number().nullable(),
    significance: zod_1.z.nativeEnum(statistical_significance_rating_1.StatisticalSignificanceQualitativeRating).nullable(),
});
exports.BootstrapCiSchema = zod_1.z.object({
    mean: zod_1.z.number(),
    ciLow: zod_1.z.number(),
    ciHigh: zod_1.z.number(),
    n: zod_1.z.number().int().nonnegative(),
});
const OperatorScorecardStepSchema = zod_1.z.object({
    meanDelta: zod_1.z.number().nullable(),
    attributionTotals: AttributionCountsSchema,
    pairedTest: exports.PairedTestResultSchema.nullable(),
    fdrAdjustedPValue: zod_1.z.number().nullable(),
    fdrAdjustedSignificance: zod_1.z.nativeEnum(statistical_significance_rating_1.StatisticalSignificanceQualitativeRating).nullable(),
});
exports.HeatmapCellSchema = zod_1.z.object({
    op: zod_1.z.number().nullable(),
    ai: zod_1.z.number().nullable(),
    delta: zod_1.z.number().nullable(),
    n: zod_1.z.number().int().nonnegative(),
    regressionRate: zod_1.z.number(),
    pValue: zod_1.z.number().nullable(),
    significance: zod_1.z.nativeEnum(statistical_significance_rating_1.StatisticalSignificanceQualitativeRating).nullable(),
});
exports.HeatmapRowSchema = zod_1.z.object({
    packageSigmaModelType: zod_1.z.string(),
    reviewCount: zod_1.z.number().int().nonnegative(),
    cells: zod_1.z.record(zod_1.z.string(), exports.HeatmapCellSchema),
});
exports.HeatmapStatsSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.HeatmapRowSchema),
});
exports.OperatorScorecardSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    displayLabel: zod_1.z.string(),
    reviewCount: zod_1.z.number().int().nonnegative(),
    reviewsWhereOperatorBeatAi: zod_1.z.number().int().nonnegative(),
    reviewsWhereOperatorLostToAi: zod_1.z.number().int().nonnegative(),
    meanOverallDelta: zod_1.z.number().nullable(),
    perStep: zod_1.z.record(zod_1.z.string(), OperatorScorecardStepSchema),
    winRateStats: exports.WinRateStatsSchema.nullable(),
    pairedTest: exports.PairedTestResultSchema.nullable(),
    bootstrapCi: exports.BootstrapCiSchema.nullable(),
});
//# sourceMappingURL=operator-eval-dto.js.map